<div class="tax-forms-country-selector">
  <particle-selector *ngIf="hasData"
                     [items]="filteredCountries"
                     [hasArrowBack]="false"
                     [displayKey]="'name'"
                     [selectorTitle]="'Country'"
                     [searchKey]="'countrySynonyms'"
                     [isCountrySelector]="true"
                     (applySelection)="onFilterChange($event)">
  </particle-selector>
</div>
<div *ngIf="!hasData">
  <i>No countries found.</i>
</div>



